import $ from 'jquery'

$(document).on('turbo:load turbo:render', () => {
  const selectEstate = $('#ticket_estate')
  if (!selectEstate.length) return // Not on the new ticket page

  const selectTicketKind = $('#ticket_ticket_kind_id')
  const costCenterNames = $('#ticket_cost_center').data('idcostcenters')

  // Populate cost_center
  const setTicketKindCostCenter = () => {
    const ticketKindId = selectTicketKind.find(':selected').val()
    const costCenterName = costCenterNames?.[ticketKindId]
    if (costCenterName) {
      // Set disabled text field
      $('#cost_center_showonly').val(costCenterName)
      // Set hidden field
      $('#ticket_cost_center').val(costCenterName)
    } else {
      // Clear that stuff
      $('#cost_center_showonly').val('')
      $('#ticket_cost_center').val('')
    }
  }

  selectTicketKind.off('change.ticketKindCostCenter').on('change.ticketKindCostCenter', setTicketKindCostCenter)

  // Also after page (re)load, e.g. validation fail
  setTicketKindCostCenter()
})
